/* ============================================================
   Bedtextielonline — site-wide maatgeheugen (custom, Claude)

   Onthoudt de laatst gekozen maten (localStorage) en selecteert
   die automatisch voor op productpagina's:
   - bron 1: maatkeuze in de variant picker (variant:change)
   - bron 2: maat-achtige waarden in filter-URL's op collecties

   Matching is dimensie-gebaseerd: elke maat wordt ontleed in
   breedtes en lengtes (ook uit labels als
   "2-persoons (140/160 x 200/220 cm)"), en er is een match zodra
   minstens één breedte én één lengte overlappen.

   Domeinscheiding: matrasmaten (hoeslaken/lakenset/molton/topper),
   dekbedmaten (dekbedovertrek/dekbed) en kussenmaten (kussen/sloop)
   zijn gescheiden werelden. Dimensie-matching gebeurt alleen binnen
   hetzelfde domein, zodat een 160-bed nooit een 140-dekbedovertrek
   voorgeselecteerd krijgt. Exacte tekstmatch mag altijd.

   Spelregels:
   - een expliciete ?variant=-link wint altijd (geen override)
   - exacte tekstmatch heeft voorrang op dimensie-match
   - uitverkochte/disabled opties worden nooit voorgeselecteerd
   ============================================================ */
(function () {
  var KEY = 'btol_maat_memory';
  var DIM_RE = /(\d+(?:\/\d+)*)\s*[x×]\s*(\d+(?:\/\d+)*)/;

  function norm(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function parseDims(value) {
    var m = norm(value).match(DIM_RE);
    if (!m) return null;

    return {
      breedtes: m[1].split('/').map(Number),
      lengtes: m[2].split('/').map(Number)
    };
  }

  function overlapt(a, b) {
    return a.some(function (n) { return b.indexOf(n) !== -1; });
  }

  function dimsMatch(a, b) {
    return a && b && overlapt(a.breedtes, b.breedtes) && overlapt(a.lengtes, b.lengtes);
  }

  function domainOf(productType) {
    var t = norm(productType).toLowerCase();
    if (!t) return null;
    if (/dekbed|overtrek/.test(t)) return 'dekbed';
    if (/kussen|sloop/.test(t)) return 'kussen';
    if (/hoeslaken|laken|molton|topper|split/.test(t)) return 'bed';
    return null;
  }

  function currentDomain() {
    try {
      var product = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) ||
                    (window.meta && window.meta.product);
      return product ? domainOf(product.type) : null;
    } catch (e) {
      return null;
    }
  }

  function load() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY)) || [];
      return list.map(function (entry) {
        return typeof entry === 'string' ? { m: entry, d: null } : entry;
      });
    } catch (e) {
      return [];
    }
  }

  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 5))); } catch (e) {}
  }

  function remember(value, domain) {
    value = norm(value);
    if (!value || !parseDims(value)) return;

    var list = load().filter(function (entry) { return entry.m !== value; });
    list.unshift({ m: value, d: domain || null });
    save(list);
  }

  /* bron 1: maatkeuze op productpagina's */
  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    var domain = currentDomain();
    (variant.options || []).forEach(function (value) { remember(value, domain); });
  });

  /* bron 2: maat-filters in de URL (domein onbekend => alleen exacte matches) */
  try {
    new URLSearchParams(location.search).forEach(function (value) {
      String(value).split(',').forEach(function (v) { remember(v, null); });
    });
  } catch (e) {}

  /* voorselectie op productpagina's */
  function kies(el) {
    var input = document.getElementById(el.getAttribute('for'));
    if (input && !input.checked && !input.disabled) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function apply() {
    if (/[?&]variant=/.test(location.search)) return;

    var stored = load();
    if (!stored.length) return;

    var els = [].slice.call(
      document.querySelectorAll('.product-info .popover__value-option, .product-info label.block-swatch')
    ).filter(function (el) { return !el.classList.contains('is-disabled'); });
    if (!els.length) return;

    var domain = currentDomain();

    for (var i = 0; i < stored.length; i++) {
      var entry = stored[i];

      /* exacte tekstmatch mag altijd */
      for (var j = 0; j < els.length; j++) {
        if (norm(els[j].textContent) === entry.m) {
          kies(els[j]);
          return;
        }
      }

      /* dimensie-match alleen binnen hetzelfde domein */
      if (!entry.d || !domain || entry.d !== domain) continue;

      var entryDims = parseDims(entry.m);
      for (var k = 0; k < els.length; k++) {
        if (dimsMatch(entryDims, parseDims(els[k].textContent))) {
          kies(els[k]);
          return;
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
